import React, { useState } from 'react';
import { FormGroup } from "react-bootstrap";

const CustomCheckbox = React.forwardRef( ( { label, name, register }, ref ) => {
    const [ checked, setChecked ] = useState( false );
    return (<FormGroup className={ "col-xs-6 col-sm-4" }>
            <div className="checkBox">
                <label>
                    <input
                        checked={ checked }
                        name={ name }
                        ref={ register }
                        value={ label }
                        type="checkbox"
                        onChange={ event => setChecked( event.target.checked ) }
                        key={ label }
                    />
                    { label }
                </label>
            </div>
        </FormGroup>
    );
} );

export default CustomCheckbox;
